// @flow
import React from 'react';
import { pure } from 'recompose';
import { Button, Modal } from 'angieslist-react-components';
import type { ServiceProviderImage } from '../../../../app/common/images/imagesService';

type Props = {
  image: ServiceProviderImage,
  isLoading: boolean,
  browser: {
    lessThan: {
      sm: boolean,
    }
  },
  onRemove: (image: ServiceProviderImage, event: any) => any,
  onRequestHide: () => any,
  show: any,
};

const ImageRemoveModalComponent = ({
  image,
  isLoading,
  browser,
  onRemove,
  onRequestHide,
  show,
}: Props) => (
  <Modal show={show} onHide={onRequestHide} animate={false} backdrop>
    <Modal.Header closeButton>
      <Modal.Title>Delete photo from image gallery</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        <img
          style={{ maxWidth: '50%' }}
          src={image.url}
          alt={image.title || image.caption || image.id}
          className="img-responsive img-thumbnail center-block"
        />
      </div>
      <p style={{ textAlign: 'center', marginTop: 20 }}>Are you sure you want to remove this photo from your gallery?</p>
    </Modal.Body>
    <Modal.Footer>
      <Button
        id="image-remove-modal--cancel-button"
        bsSize="small"
        bsStyle="default-office"
        onClick={onRequestHide}
        block={browser.lessThan.sm}
      >
          Cancel
      </Button>
      <Button
        id="image-remove-modal--remove-button"
        bsSize="small"
        bsStyle="primary-office"
        onClick={event => onRemove(image, event)}
        disabled={isLoading}
        loading={isLoading}
        block={browser.lessThan.sm}
      >
          Delete Photo
      </Button>
    </Modal.Footer>
  </Modal>

);

export default (pure(ImageRemoveModalComponent): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/ImageRemoveModal.js